import {
  ContentPage,
  ContentSection,
  ContentSectionGroup,
  ContentSectionPaged,
} from '@nrwl/rx-service-content-editor';
import { SearchModel, SearchType } from '@nrwl/rx-models';

import { SelectionModel } from '@angular/cdk/collections';

export interface ContentState {
  categories?: ContentSectionGroup[] | any;
  categoryItems?: ContentSection[] | any;
  categoryItemPages?: ContentPage[] | any;
  selectedCategories: SelectionModel<any>;
  selectedCategoryItem?: ContentSection | any;
  selectedCategoryItemId?: number | any;
  busyCategories: SelectionModel<any> | any;
  sectionPages?: any[] | any;
  selectedPage?: any;
  search?: SearchModel[] | any;
  leftViewMode: SearchType | any;
  rightViewMode: SearchType | any;
  skipUpdateContentSection: boolean | any;
  mediaDataObj: {
    [key: string]: { back_end: number | any; front_end: string | any; type: string | any }[];
  };
  showPreview: boolean;
  error: string;
}

export const initialContentState: ContentState = {
  categories: [],
  categoryItems: [],
  sectionPages: [],
  selectedPage: null,
  categoryItemPages: [],
  selectedCategories: new SelectionModel<any>(true, []),
  selectedCategoryItem: null,
  selectedCategoryItemId: null,
  busyCategories: new SelectionModel<any>(true, []),
  search: [],
  skipUpdateContentSection: false,
  showPreview: false,
  mediaDataObj: {},
  leftViewMode: SearchType.GlobalLibrary,
  rightViewMode: SearchType.AccountLibrary,
  error: '',
};
